module.exports = __webpack_public_path__ + "images/switch_on_wca_afec677c8e89ae88cf808c59931876b7.svg";